import { createActionCreator } from 'deox';
import { OrganisationMembership, UserMembership, Paging } from '@/types';

export const fetchMembersActions = {
  request: createActionCreator(
    'FETCH_MEMBERS_REQUEST',
    (resolve) => (
      organisationId: string,
      searchText?: string,
      pageSize?: string | number,
      pageNumber?: string | number,
    ) => resolve({ organisationId, searchText, pageSize, pageNumber }),
  ),
  success: createActionCreator(
    'FETCH_MEMBERS_SUCCESS',
    (resolve) => (
      data: { organisation: OrganisationMembership; user: UserMembership }[],
      paging: Paging,
    ) => resolve({ data, paging }),
  ),
  failure: createActionCreator('FETCH_MEMBERS_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const deleteMemberActions = {
  request: createActionCreator(
    'DELETE_MEMBER_REQUEST',
    (resolve) => (organisationId: string, memberId: string) =>
      resolve({ organisationId, memberId }),
  ),
  success: createActionCreator('DELETE_MEMBER_SUCCESS'),
  failure: createActionCreator('DELETE_MEMBER_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const getUserInfoActions = {
  request: createActionCreator('USER_INFO_REQUEST', (resolve) => () => resolve()),
  success: createActionCreator(
    'USER_INFO_SUCCESS',
    (resolve) => (
      email: string,
      memberships: {
        membershipId: string;
        organisationId: string;
        roleName: string;
        token: string;
        organisationName: string;
      }[],
      userId: string,
      firstName?: string,
      lastName?: string,
    ) => resolve({ email, memberships, userId, firstName, lastName }),
  ),
  failure: createActionCreator('USER_INFO_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const updateUserInfoActions = {
  request: createActionCreator(
    'UPDATE_USER_INFO_REQUEST',
    (resolve) => (firstName: string, lastName: string, userId: string) =>
      resolve({ firstName, lastName, userId }),
  ),
  success: createActionCreator('UPDATE_USER_INFO_SUCCESS', (resolve) => () => resolve()),
  failure: createActionCreator('UPDATE_USER_INFO_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const updateUserPasswordActions = {
  request: createActionCreator(
    'UPDATE_USER_PASSWORD_REQUEST',
    (resolve) => (currentPassword: string, password: string) =>
      resolve({ password, currentPassword }),
  ),
  success: createActionCreator('UPDATE_USER_PASSWORD_SUCCESS', (resolve) => () => resolve()),
  failure: createActionCreator('UPDATE_USER_PASSWORD_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};
